import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import CookieBar from './components/CookieBar';
import { api, removeToken } from './services/api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkingAuth, setCheckingAuth] = useState(true);

  // Verifica autenticazione all'avvio
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setCheckingAuth(false);
        return;
      }

      // Verifica che il token sia ancora valido
      const response = await api.getCurrentUser();
      setUser(response.user);
    } catch (err) {
      // Token non valido o scaduto
      removeToken();
      setUser(null);
    } finally {
      setCheckingAuth(false);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    removeToken();
    setUser(null);
    window.location.reload();
  };

  // Mostra loader durante il check dell'autenticazione
  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  // Se l'utente non è autenticato, mostra la pagina di login
  if (!user) {
    return (
      <>
        <AuthPage onLogin={handleLogin} />
        <CookieBar />
      </>
    );
  }

  // Se l'utente è autenticato, mostra la dashboard
  return (
    <>
      <Dashboard user={user} onLogout={handleLogout} onUpdateUser={setUser} />
      <CookieBar />
    </>
  );
}

export default App;